import React from "react";
import { bgColors } from "../../Annotation/AnnotationTextMenu/constants";
import ColorPicker from "./ColorPicker";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
const BorderColorButton = (props: any) => {
  const { handleFormatChange } = props;
  const [isShown, setIsShown]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] =
    React.useState<boolean>(false);

  return (
    <React.Fragment>
      <div className="toolbar-btn-container">
        <button
          className="wysiwyg-toolbar-btn"
          id="border-color"
          onClick={() => setIsShown(!isShown)}
          data-tooltip-id="BorderColor"
        >
          <Tooltip id="BorderColor" />
          <span className="icon-Counter-contour-color">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4"></span>
            <span className="path5"></span>
          </span>
        </button>
        {isShown ? (
          <ColorPicker
            isShown={isShown}
            keyValue={"borderColor"}
            handleFormatChange={handleFormatChange}
            setIsShown={setIsShown}
            colors={bgColors}
          />
        ) : (
          <></>
        )}
      </div>
    </React.Fragment>
  );
};

export default BorderColorButton;
